<script>
export default {
  name: 'AsideMenu',

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    renderMenuItem() {
      const { title, svgIcon, icon, router } = this.item
      return (
        <el-menu-item index={router.name} route={router}>
          {icon ? <i class={icon}></i> : null}
          {svgIcon ? (
            <svg>
              <use xlinkHref={`#${svgIcon}`}></use>
            </svg>
          ) : null}
          <span slot="title">{title}</span>
        </el-menu-item>
      )
    },

    renderSubMenu() {
      const { title, icon, svgIcon, children } = this.item
      return (
        <el-submenu index={title}>
          <template slot="title">
            {icon ? <i class={icon}></i> : null}
            {svgIcon ? (
              <svg>
                <use xlinkHref={`#${svgIcon}`}></use>
              </svg>
            ) : null}
            <span>{title}</span>
          </template>
          {children.map((childItem) => (
            <AsideMenu item={childItem} />
          ))}
        </el-submenu>
      )
    },
  },

  render() {
    return Array.isArray(this.item.children) && this.item.children.length ? this.renderSubMenu() : this.renderMenuItem()
  },
}
</script>
